var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper forget-email-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row login-white-wrap whiteBG-wrap login-margin"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('div', {
    staticClass: "email-login-form"
  }, [_c('div', {
    staticClass: "left-login"
  }, [_vm._m(0), _c('div', [_c('router-link', {
    staticClass: "login-highlight back-btn-pwd",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Back")])], 1)]), _c('h4', {
    staticClass: "login-title mb-1"
  }, [_vm._v("Recover Your Login Email")]), _c('p', {
    staticClass: "sub-head mb-2"
  }, [_vm._v("Enter the details below to securely retrieve your registered email address.")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.verifyMember.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "form-group mb-3",
    attrs: {
      "label": "Rep Code",
      "label-for": "repcode"
    }
  }, [_c('b-form-input', {
    class: {
      'is-invalid': _vm.formErrors.repcode
    },
    attrs: {
      "id": "repcode",
      "type": "text",
      "placeholder": "Enter your rep code",
      "aria-describedby": "repcode-help repcode-error",
      "autocomplete": "off",
      "aria-required": "true"
    },
    model: {
      value: _vm.repcode,
      callback: function callback($$v) {
        _vm.repcode = $$v;
      },
      expression: "repcode"
    }
  }), !_vm.formErrors.repcode ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "repcode-help"
    }
  }, [_vm._v(" Enter your representative code ")]) : _vm._e(), _vm.formErrors.repcode ? _c('div', {
    staticClass: "valid-error",
    attrs: {
      "id": "repcode-error",
      "role": "alert",
      "aria-live": "polite"
    }
  }, [_vm._v(" " + _vm._s(_vm.formErrors.repcode) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    staticClass: "form-group mb-3",
    attrs: {
      "label": "Last Name",
      "label-for": "lastname"
    }
  }, [_c('b-form-input', {
    class: {
      'is-invalid': _vm.formErrors.lastname
    },
    attrs: {
      "id": "lastname",
      "type": "text",
      "placeholder": "Enter your last name",
      "aria-describedby": "lastname-help lastname-error",
      "autocomplete": "family-name",
      "aria-required": "true"
    },
    model: {
      value: _vm.lastname,
      callback: function callback($$v) {
        _vm.lastname = $$v;
      },
      expression: "lastname"
    }
  }), !_vm.formErrors.lastname ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "lastname-help"
    }
  }, [_vm._v(" Enter the last name associated with your account ")]) : _vm._e(), _vm.formErrors.lastname ? _c('div', {
    staticClass: "valid-error",
    attrs: {
      "id": "lastname-error",
      "role": "alert",
      "aria-live": "polite"
    }
  }, [_vm._v(" " + _vm._s(_vm.formErrors.lastname) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    staticClass: "form-group mb-3",
    attrs: {
      "label": "Last 4 Digits of SSN or Full EIN (9 Digits)",
      "label-for": "cssn"
    }
  }, [_c('b-form-input', {
    class: {
      'is-invalid': _vm.formErrors.cssn
    },
    attrs: {
      "id": "cssn",
      "type": "text",
      "maxlength": "9",
      "placeholder": "Enter SSN (4 digits) or EIN (9 digits)",
      "aria-describedby": "cssn-help cssn-error",
      "autocomplete": "off",
      "inputmode": "numeric",
      "aria-required": "true"
    },
    on: {
      "input": _vm.onCssnInput,
      "keypress": _vm.onCssnKeypress
    },
    model: {
      value: _vm.cssn4,
      callback: function callback($$v) {
        _vm.cssn4 = $$v;
      },
      expression: "cssn4"
    }
  }), !_vm.formErrors.cssn ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "cssn-help"
    }
  }, [_vm._v(" Enter the last 4 digits of your SSN or full 9-digit EIN ")]) : _vm._e(), _vm.formErrors.cssn ? _c('div', {
    staticClass: "valid-error",
    attrs: {
      "id": "cssn-error",
      "role": "alert",
      "aria-live": "polite"
    }
  }, [_vm._v(" " + _vm._s(_vm.formErrors.cssn) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    staticClass: "form-group mb-3",
    attrs: {
      "label": "Date of Birth",
      "label-for": "dob"
    }
  }, [_c('div', {
    staticClass: "date_of_birth",
    attrs: {
      "role": "group",
      "aria-label": "Date of Birth",
      "aria-required": "true"
    }
  }, [_c('b-form-select', {
    staticClass: "m-0",
    class: {
      'is-invalid': _vm.formErrors.dob
    },
    attrs: {
      "options": _vm.months,
      "aria-label": "Month",
      "aria-describedby": "dob-help dob-error"
    },
    model: {
      value: _vm.selected_month,
      callback: function callback($$v) {
        _vm.selected_month = $$v;
      },
      expression: "selected_month"
    }
  }), _c('b-form-select', {
    staticClass: "m-0",
    class: {
      'is-invalid': _vm.formErrors.dob
    },
    attrs: {
      "options": _vm.days,
      "aria-label": "Day"
    },
    model: {
      value: _vm.selected_day,
      callback: function callback($$v) {
        _vm.selected_day = $$v;
      },
      expression: "selected_day"
    }
  }), _c('b-form-select', {
    staticClass: "m-0",
    class: {
      'is-invalid': _vm.formErrors.dob
    },
    attrs: {
      "options": _vm.years,
      "aria-label": "Year"
    },
    model: {
      value: _vm.selected_year,
      callback: function callback($$v) {
        _vm.selected_year = $$v;
      },
      expression: "selected_year"
    }
  })], 1), !_vm.formErrors.dob ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "dob-help"
    }
  }, [_vm._v(" Select your date of birth (Month, Day, Year) ")]) : _vm._e(), _vm.formErrors.dob ? _c('div', {
    staticClass: "valid-error",
    attrs: {
      "id": "dob-error",
      "role": "alert",
      "aria-live": "polite"
    }
  }, [_vm._v(" " + _vm._s(_vm.formErrors.dob) + " ")]) : _vm._e()]), _vm.formErrors.error ? _c('div', {
    staticClass: "valid-error",
    attrs: {
      "role": "alert",
      "aria-live": "assertive"
    }
  }, [_vm._v(" " + _vm._s(_vm.formErrors.error) + " ")]) : _vm._e(), _c('button', {
    staticClass: "submit-btn mt-3 next-btn ml-0",
    attrs: {
      "type": "submit",
      "disabled": _vm.verifyLoader,
      "aria-busy": _vm.verifyLoader,
      "aria-label": "Continue to recover email"
    }
  }, [_vm.verifyLoader ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), !_vm.verifyLoader ? _c('span', [_vm._v("Continue")]) : _c('span', [_vm._v("Processing...")])], 1), _c('div', {
    staticClass: "login-signup-btn-wrap mb-0 login-highlight d-flex justify-content-between align-items-center"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('router-link', {
    staticClass: "text-link login-highlight",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Already have an account? Login")])], 1), _c('p', {
    staticClass: "mb-0"
  }, [_c('router-link', {
    staticClass: "text-link login-highlight",
    attrs: {
      "to": "/registration"
    }
  }, [_vm._v("New representative? Register here")])], 1)])], 1)])])])]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding p-0"
  }, [_c('LoginCarsoule')], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "Rep login icon"
    }
  })]);
}]

export { render, staticRenderFns }